import { render } from "./Exif.vue?vue&type=template&id=21ffbf94&ts=true"
import script from "./Exif.vue?vue&type=script&lang=ts"
export * from "./Exif.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__